import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) => ({
  link: {
    color: `${theme.palette.primary.main} !important`,
    cursor: 'pointer',
    textDecoration: 'initial !important',
    '&:hover': {
      textDecoration: 'underline !important',
    },
  },
}));

interface StyledLinkProps extends RouterLinkProps {
  onClick?: (e) => void
  children: React.ReactNode
}

const StyledLink: React.FC<StyledLinkProps> = ({ to, onClick, children, ...props }) => {
  const classes = useStyles();

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <RouterLink
      to={to}
      onClick={handleClick}
      className={classes.link}
      target="_blank"
      {...props}
    >
      {children}
    </RouterLink>
  );
};

export default StyledLink;
